module.exports = __webpack_public_path__ + "img/center back length to hem.09eb2eb2.png";